import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commonActions from '../../../app/common/common.action';
import * as macroActions from '../../../pages/laudo/etapas/macroscopia/macroscopia.action';

import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';
import SelectAsyncComponent from '../../../componentes/select/select-async.component';
import CheckBox from '../../../componentes/checkbox/checkbox.component';
import '../../../pages/laudo/etapas/macroscopia/operacoes/blocos/gerar-blocos.styles.css';
import WebapiCommon from '../../../app/common/util/webapi.common';
import CitologiaApi from './citologia.api';
import { getUsuarioLocalStorage } from '../../../localStorage.util';
import SelectComponent from '@componentes/select/select.component';
import SelectCreatableComponent from '@componentes/select/select-creatable.component';

import IntlMessage from "../../../helpers/intlMessage";

class CitologiaCassetesContainer extends Component {
  constructor() {
    super();
    this.usuario = getUsuarioLocalStorage();
    this.pesquisarValidadeNExame = this.pesquisarValidadeNExame.bind(this);
    this.state = {
      laudo: '',
      nrExame: '',
      laudoIsValido: false,
      frascos: [],
      frasco: null,
      numeroBlocos: 1,
      variosFragmentos: false,
      numeroFragmentos: 1,
      novoscortes: false,
      coloracao: false,
      antigeno: false,
      coloracoes: [],
      coloracaoSelecionada: null,
      antigenoSelecionado: null,
      antigenos: [],
      materiais: [],
      material: null,
      tipos: [],
      tipo: {
        label: <IntlMessage id = "dashboards.cytology.cytology"/>,
        value: 'Citologia',
      },
      sentinelaMelanoma: false,
      sentinelaMama: false,
      medicoTecnico: [],
      tecnico: null,
      medicoMacro: [],
      medico: null,
      anotacoes: '',
    };
  }

  render() {
    const {
      anotacoes,
      medico,
      medicoMacro,
      tecnico,
      medicoTecnico,
      // sentinelaMama,
      // sentinelaMelanoma,
      tipo,
      tipos,
      material,
      materiais,
      antigenos,
      antigenoSelecionado,
      coloracaoSelecionada,
      coloracoes,
      antigeno,
      frascos,
      frasco,
      numeroBlocos,
      variosFragmentos,
      numeroFragmentos,
      novoscortes,
      coloracao,
      // laudo,
      nrExame,
      laudoIsValido,
    } = this.state;

    return (
      <Modal isOpen={this.props.open} toggle={this.props.toggle} size='lg'>
        <div className='citologia-modal-page'>
          <ModalHeader toggle={this.props.toggle}>
            <IntlMessage id = "dashboards.cytology.addCassetes"/>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col sm={2}>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.cytology.numberExam"/></Label>
                  <Input
                    value={nrExame}
                    onChange={(e) => this.onChangeNrExame(e.target.value)}
                    disabled={laudoIsValido}
                    onKeyPress={(ev) => {
                      ev.key === 'Enter' && this.pesquisarValidadeNExame();
                    }}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.cytology.bottles"/></Label>
                  <SelectComponent
                    isMulti
                    onChange={(e) => this.setState({ frasco: e })}
                    options={frascos}
                    placeholder={this.props.intl.formatMessage({ id:"dashboards.cytology.selectBottle"})}
                    value={frasco}
                    disabled={!laudoIsValido}
                  />
                </FormGroup>
              </Col>
              <Col sm={3}>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.cytology.numberOfCassetes"/></Label>
                  <Input
                    value={numeroBlocos}
                    onChange={(e) =>
                      this.setState({ numeroBlocos: e.target.value })
                    }
                    name='numeroBlocos'
                    type='number'
                    min='1'
                    max='10'
                    disabled={!laudoIsValido}
                  />
                </FormGroup>
              </Col>
              <Col sm={3}>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.cytology.fragmentsCassette"/></Label>
                  {variosFragmentos && (
                    <Input
                      value={'N/D'}
                      name='numeroFragmentos'
                      type='text'
                      disabled={variosFragmentos}
                    />
                  )}
                  {!variosFragmentos && (
                    <Input
                      value={numeroFragmentos}
                      onChange={(e) =>
                        this.setState({ numeroFragmentos: e.target.value })
                      }
                      name='numeroFragmentos'
                      type='number'
                      min='1'
                      max='10'
                      disabled={!laudoIsValido}
                    />
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={'auto'}>
                <FormGroup style={{ marginTop: '3px' }}>
                  <CheckBox
                    label={<IntlMessage id = "dashboards.cytology.multipleFragments"/>}
                    name='checkVariosFragmentos'
                    disabled={!laudoIsValido}
                    onChange={(e) =>
                      this.setState({ variosFragmentos: e.target.checked })
                    }
                    checked={variosFragmentos}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup style={{ marginTop: '3px' }}>
                  <CheckBox
                    label={<IntlMessage id = "dashboards.cytology.newCuts"/>}
                    name='checkNovosCortes'
                    onChange={(e) =>
                      this.setState({ novoscortes: e.target.checked })
                    }
                    checked={novoscortes}
                    disabled={!laudoIsValido}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup style={{ marginTop: '3px' }}>
                  <CheckBox
                    label={<IntlMessage id = "dashboards.taskControl.coloring"/>}
                    name='checkColoracao'
                    onChange={(e) =>
                      this.setState({ coloracao: e.target.checked })
                    }
                    checked={coloracao}
                    disabled={!laudoIsValido}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup style={{ marginTop: '3px' }}>
                  <CheckBox
                    label={<IntlMessage id = "dashboards.examDetail.antigen"/>}
                    name='checkAntigeno'
                    onChange={(e) =>
                      this.setState({ antigeno: e.target.checked })
                    }
                    checked={antigeno}
                    disabled={!laudoIsValido}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                {
                  <FormGroup style={{ display: coloracao ? 'block' : 'none' }}>
                    <Label><IntlMessage id = "dashboards.cytology.colors"/></Label>
                    <SelectComponent
                      isMulti
                      onChange={(e) =>
                        this.setState({ coloracaoSelecionada: e })
                      }
                      options={coloracoes}
                      placeholder={this.props.intl.formatMessage({ id:"general.requestsPanel.selectColors"})}
                      value={coloracaoSelecionada}
                      disabled={!laudoIsValido}
                    />
                  </FormGroup>
                }
              </Col>
            </Row>
            <Row>
              <Col>
                {
                  <FormGroup style={{ display: antigeno ? 'block' : 'none' }}>
                    <Label><IntlMessage id = "dashboards.examDetail.antigen"/>:</Label>
                    <SelectComponent
                      isMulti
                      onChange={(e) =>
                        this.setState({ antigenoSelecionado: e })
                      }
                      options={antigenos}
                      placeholder={this.props.intl.formatMessage({ id:"dashboards.cytology.selectAntigens"})}
                      value={antigenoSelecionado}
                      disabled={!laudoIsValido}
                    />
                  </FormGroup>
                }
              </Col>
            </Row>
            {/* <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.examDetail.Material"/></Label>
                  <SelectAsyncComponent
                    createTable={true}
                    onChange={(e) => this.setState({ material: e })}
                    options={materiais}
                    placeholder={this.props.intl.formatMessage({ id:"dashboards.cytology.selectMaterial"})}
                    value={material}
                    onCreateOption = {handleCreateSelectCreatable}
                    label = {this.props.intl.formatMessage({ id:"dashboards.examDetails.registerNewMaterial"})}
                    disabled={!laudoIsValido}
                  />
                </FormGroup>
              </Col>
            </Row> */}

            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.examDetail.Material"/></Label>
                  <SelectCreatableComponent
                    disabled={!laudoIsValido}
                    // innerRef={props.materialRef}
                    onChange={(e) => this.setState({ material: e })}
                    onCreateOption={this.handleCreateSelectCreatable}
                    options={materiais}
                    placeholder={this.props.intl.formatMessage({ id:"dashboards.cytology.selectMaterial"})}
                    label={this.props.intl.formatMessage({ id:"dashboards.examDetails.registerNewMaterial"})}
                    // tabIndex={props.getTabIndex('material')}
                    value={material}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.cytology.type"/></Label>
                  <SelectComponent
                    disabled={true}
                    options={tipos}
                    placeholder={this.props.intl.formatMessage({ id:"dashboards.examDetail.typeSelect"})}
                    value={tipo}
                  />
                </FormGroup>
              </Col>
              {/* <Col>
                <FormGroup check>
                  <Label check style={{ userSelect: 'none' }}>
                    <Input
                      type='radio'
                      name='sentinela'
                      //onClick={() => { props.updateValorSentinela('sentinelaMelanoma') }}
                      //checked={sentinelaMelanoma}
                    />{' '}
                    <IntlMessage id = "dashboards.cytology.melanomaSentinel"/>
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Label check style={{ userSelect: 'none' }}>
                    <Input
                      type='radio'
                      name='sentinela'
                      //onClick={() => { props.updateValorSentinela('sentinelaMama') }}
                      //checked={sentinelaMama}
                    />{' '}
                    <IntlMessage id = "dashboards.cytology.mamaSentry"/>
                  </Label>
                </FormGroup>
              </Col> */}
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.cytology.macroscopyTechnician"/></Label>
                  <SelectAsyncComponent
                    options={medicoTecnico}
                    value={tecnico}
                    onChange={(e) => this.setState({ tecnico: e })}
                    placeholder={this.props.intl.formatMessage({ id:"dashboards.examDetail.selectTechnician"})}
                    disabled={!laudoIsValido}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.cytology.doctorMacroscopy"/></Label>
                  <SelectAsyncComponent
                    options={medicoMacro}
                    value={medico}
                    onChange={(e) => this.setState({ medico: e })}
                    placeholder={this.props.intl.formatMessage({ id:"dashboards.cytology.selectDoctor"})}
                    disabled={!laudoIsValido}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.examDetail.annotations"/></Label>
                  <Input
                    type='textarea'
                    value={anotacoes}
                    onChange={(e) =>
                      this.setState({ anotacoes: e.currentTarget.value })
                    }
                    disabled={!laudoIsValido}
                  />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter className='paddingTop-none'>
            {laudoIsValido && (
              <Button color='danger' onClick={this.limparCampos.bind(this)}>
                <IntlMessage id = "dashboards.examDetail.clearFields"/>
              </Button>
            )}
            <Button color='secondary' onClick={this.props.toggle}>
              <IntlMessage id = "dashboards.examDetails.cancel"/>
            </Button>
            <Button
              color='primary'
              disabled={
                (!laudoIsValido && frasco === null) ||
                material === null ||
                medico === null ||
                tecnico === null
              }
              onClick={this.adicionarCassete.bind(this)}
            >
              <IntlMessage id = "dashboards.cytology.addCassete"/>
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    );
  }

  onChangeNrExame = (nrExame) =>
    this.setState({ nrExame, laudoIsValido: false });

  pesquisarValidadeNExame() {
    const { nrExame } = this.state;
    this.props.commonActions.showFadeCarregando(true);
    let medicoPadrao = this.props.medicoPadrao;

    WebapiCommon.laudoExiteEMaterialFoiFinalizado(encodeURIComponent(nrExame))
      .then((res) => {
        this.setState({ laudo: res.laudo, laudoIsValido: true });
        Promise.all([
          WebapiCommon.getFrascos(res.laudo),
          WebapiCommon.getMaterial(),
          WebapiCommon.getMedicos(),
          WebapiCommon.obterUsuarios(),
          WebapiCommon.getColoracoes(),
          WebapiCommon.getAntigenos(),
        ]).then((resArray) => {
          let medico = this.state.medico;
          if (medicoPadrao !== null) {
            let encontrouMedico = resArray[2].find(
              (el) => el.value === medicoPadrao
            );
            if (encontrouMedico) {
              medico = encontrouMedico;
            }
          }

          this.setState({
            frascos: resArray[0]
              .filter((el) => el.status !== <IntlMessage id = "dashboards.cytology.cancel"/>)
              .map((frasco) => ({
                value: frasco.frascoId,
                label: frasco.dsFrasco,
              })),
            materiais: resArray[1],
            medicoMacro: resArray[2],
            medico,
            medicoTecnico: resArray[3],
            tecnico: {
              label: this.usuario.usuarioId + ' - ' + this.usuario.usuario,
              value: this.usuario.usuarioId,
            },
            coloracoes: resArray[4],
            antigenos: resArray[5],
          });

          this.props.commonActions.showFadeCarregando(false);
        });
      })
      .catch(() => this.setState({ laudoIsValido: false }));
  }

  adicionarCassete() {
    const {
      laudo,
      frasco,
      numeroBlocos,
      numeroFragmentos,
      material,
      tipo,
      medico,
      tecnico,
      novoscortes,
      variosFragmentos,
      anotacoes,
      sentinelaMama,
      sentinelaMelanoma,
      coloracao,
      coloracaoSelecionada,
      antigeno,
      antigenoSelecionado,
    } = this.state;

    if (
      frasco === null ||
      frasco.length === 0 ||
      material === null ||
      medico === null ||
      tecnico === null
    ) {
      this.props.commonActions.showAlerta(
        'erro',
        <IntlMessage id = "dashboards.cytology.allFields"/>,
        1500
      );
    } else {
      let blocos = [
        {
          frascoId: frasco.map((f) => f.value),
          cassetes: numeroBlocos,
          fragmentos: numeroFragmentos,
          materialId: material.value,
          novosCortes: novoscortes,
        },
      ];

      WebapiCommon.gerarBlocos(laudo, blocos).then((blocoResponse) => {
        const mapaMacroscopico = {
          frascoId: frasco.map((f) => f.value),
          materialId: material.value,
          medicoId: medico.value,
          tecnicoId: tecnico.value,
          tipoBloco: tipo.value,
          anotacao: anotacoes,
          sentinelaMama: sentinelaMama,
          sentinelaMelanoma: sentinelaMelanoma,
          novosCortes: novoscortes,
          coloracao: coloracao,
          coloracoesId: coloracao ? coloracaoSelecionada.map((c) => c.id) : [],
          antigeno: antigeno,
          antigenosId: antigeno ? antigenoSelecionado.map((a) => a.value) : [],
          blocos: blocoResponse.map((bloco) => ({
            bloco: bloco.bloco,
            numeroBloco: bloco.numeroBloco,
            fragmentos: variosFragmentos ? 0 : numeroFragmentos,
            nuOrdem: bloco.nuOrdem,
          })),
        };

        WebapiCommon.gravarBlocos(laudo, mapaMacroscopico).then((result) => {
          if (result.success) {
            let laminaCitologiaRequest = result.data.listaLaudoBlocoId.map(
              (el) => ({
                laudo: laudo,
                quantidade: 1,
                complemento: '',
                idUsuarioLogado: this.usuario.usuarioId,
                idMedicoPatologista: medico.value,
                idTecnico: tecnico.value,
                nomeMedicoPatologista: medico.label,
                nomeTecnico: tecnico.label,
                idNConf: null,
                cdBloco: el,
              })
            );

            laminaCitologiaRequest
              .reduce(
                (prev, curr) =>
                  prev.then(() =>
                    CitologiaApi.adicionarLaminaDeCitologia(curr)
                  ),
                Promise.resolve()
              )
              .then(() => {
                this.props.toggle();
                let message =
                  <IntlMessage id = "dashboards.cytology.successBlock"/>;
                let size = message.length * 10 + 'px';
                this.props.commonActions.showAlerta(
                  'sucesso',
                  message,
                  5000,
                  size
                );
              });
          } else {
            this.props.commonActions.showAlerta('erro', result.message, 1500);
          }
        });
      });
    }
  }

  limparCampos = () =>
    this.setState({
      laudo: '',
      nrExame: '',
      laudoIsValido: false,
      frascos: [],
      frasco: null,
      numeroBlocos: 1,
      variosFragmentos: false,
      numeroFragmentos: 1,
      novoscortes: false,
      coloracao: false,
      antigeno: false,
      coloracaoSelecionada: null,
      antigenoSelecionado: null,
      material: null,
      sentinelaMelanoma: false,
      sentinelaMama: false,
      tecnico: null,
      medico: null,
      anotacoes: '',
    });

    handleCreateSelectCreatable = (value) => {
      commonActions.showFadeCarregando(true);
      WebapiCommon.cadastrarMateriais(value).then(() => {
        WebapiCommon.getMaterial().then(res => {
          let state = { ...this.state };
          state.materiais = res;
          state.material = res.find(el => el.label.includes(value.toUpperCase()));
          this.setState(state);
          commonActions.showFadeCarregando(false);
        });
      });
    };
}

const mapStateToProps = (state) => {
  return {
    medicoPadrao: state.commonReducer.medicoPadraoMacroscopia,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CitologiaCassetesContainer);



// WEBPACK FOOTER //
// ./src/pages/citologia/content/citologia.cassetes.container.js